enum INVITATION_STATE {
	PENDING = 'PENDING',
	ACCEPTED = 'ACCEPTED',
	EXPIRED = 'EXPIRED'
}

export { INVITATION_STATE };
